var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7336_7499)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.3071 5.69286C14.6976 6.08339 14.6976 6.71655 14.3071 7.10708L11.4142 9.99997L14.3071 12.8929C14.6976 13.2834 14.6976 13.9166 14.3071 14.3071C13.9165 14.6976 13.2834 14.6976 12.8928 14.3071L9.99996 11.4142L7.10706 14.3071C6.71654 14.6976 6.08337 14.6976 5.69285 14.3071C5.30232 13.9166 5.30232 13.2834 5.69285 12.8929L8.58574 9.99997L5.69285 7.10708C5.30232 6.71655 5.30232 6.08339 5.69285 5.69286C6.08337 5.30234 6.71654 5.30234 7.10706 5.69286L9.99996 8.58576L12.8928 5.69286C13.2834 5.30234 13.9165 5.30234 14.3071 5.69286Z",
    fill: "#AEB5BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7336_7499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.fb44a76dbfcc4d91ac2bdc3d409465cf.svg";
export { ForwardRef as ReactComponent };